import { useEffect } from 'react';

interface Dot {
  x: number;
  y: number;
  radius: number;
  alpha: number;
  speed: number;
}

export const useConstellation = () => {
  useEffect(() => {
    console.log('🌟 Initializing constellation effect...');
    
    const canvas = document.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '0';
    canvas.style.opacity = '1';
    document.body.appendChild(canvas);
    
    console.log('🌟 Canvas created and added to DOM');
    
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      // Clean up canvas if context is not available
      if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
      return;
    }
    
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const dots: Dot[] = [];
    for (let i = 0; i < 50; i++) {
      dots.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        alpha: Math.random() * 0.5 + 0.1,
        speed: Math.random() * 0.5 + 0.1
      });
    }
    
    let animationId: number;
    
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      dots.forEach(dot => {
        dot.alpha += Math.sin(Date.now() * 0.001 * dot.speed) * 0.01;
        dot.alpha = Math.max(0.1, Math.min(0.6, dot.alpha));
        
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, dot.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(84, 122, 255, ${dot.alpha})`;
        ctx.fill();
      });
      
      animationId = requestAnimationFrame(animate);
    };
    
    console.log('🌟 Starting animation with', dots.length, 'dots');
    animate();
    
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      dots.forEach(dot => {
        if (dot.x > canvas.width) dot.x = Math.random() * canvas.width;
        if (dot.y > canvas.height) dot.y = Math.random() * canvas.height;
      });
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', handleResize);
      if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    };
  }, []);
};